import { inboxState } from '../../../modules/InboxModule/state';
import { tasksState } from '@modules/TasksModule/state';
import { phoneState } from '@modules/SoftPhoneModule/state';
import { liveCallSid } from '@modules/TasksModule/lib/liveCallSid';

/**
 * Computes the active call SID for the currently selected task.
 * This function only executes when called, making it perfect for on-demand computation.
 *
 * @returns The session ID if all conditions are met and the call is active, otherwise undefined
 */
export function getActiveCallSid(): string | undefined {
  const selectedTaskId = inboxState.selectedTaskId;

  return liveCallSid(selectedTaskId, {
    selectedTaskId,
    taskById: tasksState.tasks,
    callList: phoneState.callList,
  });
}
